import type { IConfigModel } from './Types';

const ConfigModel = (config?: IConfigModel) => {
  const { stripePublicKey = '', plaidEnv = '', plaidLinkToken = '', plaidLinkTokenExpiration = 0 } = config || {};

  return {
    stripePublicKey,
    plaidEnv,
    plaidLinkToken,
    plaidLinkTokenExpiration,
  };
};

export default ConfigModel;
